module.exports = __webpack_public_path__ + "img/intp.5b8b6ce8.png";